import { Link } from "react-router-dom";

const EcomSolution = () => {
  return (
    <div>
      <div className="bg-[#efefef] flex justify-center items-center h-[150px]">
        <h1 className="text-[40px] font-bold">E-Com Solutions</h1>
      </div>
      <div className="flex flex-col justify-center  gap-8 max-w-[50rem] mx-auto  p-[3rem]">
       <p>No other industry changes as rapidly and with as much effect as the E-commerce industry.
        The market of E-commerce in Pakistan is at an extremely exciting stage given that it is still 
        exploring and finding its own feet. The outlook for local entrepreneurs as well as venture capitalists 
        remains strong in the medium to long term, which has helped many businesses, small and larger, to operate 
        successfully and to build a customer base that would have been otherwise impossible to reach.</p>

       <p>With e-commerce industry booming and gaining momentum in Pakistan, TCS is leading the way, when 
        it comes to bringing everything at the doorstep of our customers. When you remove the physical boundaries 
        of a store, you offer a plethora of convenience to your customers; and this is where TCS can become your partner
        in making customers’ lives convenient and easy.</p> 
       
      </div>
    </div>
  );
};

export default EcomSolution;
